import {GenericAjaxService} from 'tds_shared_ui';
export default GenericAjaxService;
